/**
 * Hero banner slideshow — hotel stays & meeting rooms.
 * Uses public assets so the hero works reliably without external hotlinking.
 */
const publicUrl = process.env.PUBLIC_URL || '';

export const HERO_BANNER_IMAGES = [
  {
    url: `${publicUrl}/1234.png`,
    alt: 'Book your perfect stay on mobile',
    category: 'hotel',
  },
  {
    url: `${publicUrl}/images/hero/hero-1.jpg`,
    alt: 'Luxury hotel room with comfortable bed',
    category: 'hotel',
  },
  {
    url: `${publicUrl}/images/hero/hero-2.jpg`,
    alt: 'Premium hotel stay experience',
    category: 'hotel',
  },
  {
    url: `${publicUrl}/images/hero/hero-3.jpg`,
    alt: 'Cozy boutique hotel bedroom',
    category: 'hotel',
  },
  {
    url: `${publicUrl}/images/hero/hero-4.jpg`,
    alt: 'Elegant hotel interior',
    category: 'hotel',
  },
  {
    url: `${publicUrl}/home-hero-content-room.png`,
    alt: 'Spacious hotel room with booking app preview',
    category: 'hotel',
  },
  {
    url: `${publicUrl}/homepage-bg.png`,
    alt: 'Beautiful hotel room background',
    category: 'hotel',
  },
  {
    url: `${publicUrl}/conference-room-bg.jpg`,
    alt: 'Professional conference meeting room',
    category: 'meeting',
  },
  {
    url: `${publicUrl}/images/meeting-home/meeting-home-hero-boardroom.jpg`,
    alt: 'Executive boardroom for team meetings',
    category: 'meeting',
  },
];

export const getHeroBannerImageUrls = () => HERO_BANNER_IMAGES.map((item) => item.url);
